import React from 'react';
import SummaryCard from './SummaryCard';

function KeyRecommendations({ executiveSummary }) {

    return (
        <SummaryCard title="Key Recommendations">
            <div className="pb-6">
                {executiveSummary?.recommendations?.map((rec, idx) => (
                    <div key={idx} className="flex items-start mb-2">
                        <div className="w-2 h-2 rounded-full mr-3 mt-2 flex-shrink-0" style={{ backgroundColor: "#6725F4" }}></div>
                        <p className="content-text text-gray-700">{rec}</p>
                    </div>
                ))}
                <div className="flex items-start">
                    <div className="w-4 h-4 rounded-full border-2 flex items-center justify-center mr-3 mt-0.5 flex-shrink-0" style={{ border: "1px solid #6725F4" }}>
                        <div className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: "#6725F4" }}></div>
                    </div>
                    <p className="content-text text-gray-600">
                        Please discuss with your wealth partner on how you can achieve this!
                    </p>
                </div>
            </div>

            {/* Border separator */}
            {/* <div className="border-b border-gray-300 my-6"></div> */}

            {/* Enhance health insurance coverage */}
            {/* <div className="pb-6">
                <h4 className="content-text text-gray-800 font-medium mb-4">
                    <strong>Enhance</strong> health insurance coverage
                </h4>

                <div className="flex items-center gap-4">
                    <div className="flex items-center">
                        <MdFavorite className="text-red-500 w-5 h-5 mr-2" />
                        <div>
                            <p className="text-2xl font-bold text-gray-800 mb-0">{currentHealthCover}</p>
                            <p className="content-text text-gray-600">Lakh Cover</p>
                        </div>
                    </div>

                    <span className="text-gray-400 text-xl font-bold">+</span>

                    <div className="bg-purple-100 border border-purple-300 px-4 py-2 rounded-lg">
                        <span className="content-text text-purple-700 font-medium">
                            <strong>Suggest</strong> {suggestedTopUp} Lakh Top up
                        </span>
                    </div>
                </div>
            </div> */}

            {/* Border separator */}
            {/* <div className="border-b border-gray-300 my-6"></div> */}

            {/* Optimize tax-saving investments */}
            {/* <div>
                <h4 className="content-text text-gray-800 font-medium mb-4">
                    Optimize <strong>tax-saving</strong> investments
                </h4>

                <div className="space-y-2">
                    <div className="flex items-start">
                        <div className="w-2 h-2 bg-gray-400 rounded-full mr-3 mt-2 flex-shrink-0"></div>
                        <p className="content-text text-gray-700">
                            Invest ₹{elssAmount.toLocaleString()} more in ELSS for section 80C
                        </p>
                    </div>
                    <div className="flex items-start">
                        <div className="w-2 h-2 bg-gray-400 rounded-full mr-3 mt-2 flex-shrink-0"></div>
                        <p className="content-text text-gray-700">
                            This will add to your equity allocation as well!
                        </p>
                    </div>
                </div>
            </div> */}
        </SummaryCard>
    );
}

export default KeyRecommendations;
